<div class="team-activity-feed">
  <div *ngIf="loading" class="feed-loading">Loading activity...</div>

  <div *ngIf="!loading && summary">
    <div class="feed-summary">
      <div class="summary-stat">
        <span class="stat-value">{{ summary.totalActivities }}</span>
        <span class="stat-label">Activities</span>
      </div>
      <div class="summary-stat">
        <span class="stat-value">{{ summary.totalDurationSeconds | number }}</span>
        <span class="stat-label">Total Seconds</span>
      </div>
    </div>

    <table class="table table-sm mt-3">
      <thead>
        <tr>
          <th>Member</th>
          <th>Activities</th>
          <th>Duration</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let member of summary.members">
          <td>{{ member.displayName }}</td>
          <td>{{ member.totalActivities }}</td>
          <td>{{ member.totalDurationSeconds }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="!loading && !summary" class="feed-empty">
    No activity recorded yet for this team.
  </div>
</div>
